import React from 'react'
import { StaticIconProps } from '.'

export const Smith = (props: StaticIconProps) => {
  const { fill = '#fff' } = props
  return (
    <g style={{ transform: 'scale(0.01)', zIndex: 2 }}>
      <g style={{ transform: 'translate(-283px, -297px)' }}>
        <path
          d='M413.375 69.906L336.937 191.47l-8.25-32.69-30.218 88.97 62.655-29.375.22 29.438 127.03-50.938-70.813-1.97 47.782-68.686-73.47 39.25 21.5-95.564zM210.22 102.094l-32 14.406 16.874 55.656-177.813 80.03 12.564 27.876L207.656 200l30.406 49.47 49.313-22.19-21.344-70.343-55.81-54.843zM197.593 266.78v20.345h-88.906c15.994 38.807 51.225 65.43 88.906 74.28v32.97h58.562c-12.118 30.528-33.505 55.684-58.47 77.594H172.22v18.686H456.56V471.97h-27.406c-28.734-21.895-50.055-47.018-61.625-77.595h63.658v-29.188c19.748-6.995 39.5-19.51 59.25-36.687-19.812-17.523-39.23-27.25-59.25-31.938v-29.78H197.594z'
          fill={fill}
          style={{ filter: 'url(#shadow)' }}
        />
      </g>
    </g>
  )
}
